import React from "react";
import "./styles/App.css";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Routes, Route } from "react-router-dom";
import routes, { RouteConfig } from "./config/routes";
import { Layout } from "pages/Layout";
import { PageLayout } from "components/authentication/PageLayout";
import ProtectedRoute from "config/ProtectedRoute";
import { type Permission } from "./security/SecurityContext";
import { SecurityProvider } from "./security/SecurityContext";

const MainContent = () => {
  const renderRoutes = (routes: RouteConfig[]) => {
    return routes.map((route) => {
      // Permission-protected routes
      let permission: Permission | undefined;
      // if (route.path === "/users") permission = "Manage_Users";
      // if (route.path === "/groups") permission = "Manage_Roles";

      const element = permission ? (
        <ProtectedRoute permission={permission}>
          <route.component />
        </ProtectedRoute>
      ) : (<route.component />);

      return (
        <React.Fragment key={route.path}>
          <Route path={route.path} element={element} />
          {route.children && renderRoutes(route.children)}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="App">
      <AuthenticatedTemplate>
        <SecurityProvider>
          <Layout>
            <Routes>
              {renderRoutes(routes)}
            </Routes>
          </Layout>
        </SecurityProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <PageLayout />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default function App() {
  return <MainContent />;
}
